/*
 * this.$api.getApiAddress('GWC_API_HOST', '/api/login')
 */

'use strict'
const apiProvider = {}

apiProvider.apiConfig = {}
console.log(process.env.GWC_API_HOST)
// [ext] if NODE_ENV is production , load the static site-map.js
apiProvider.load = function () {
  if (process.env.NODE_ENV === 'production') {
    apiProvider.apiConfig['GWC_API_HOST'] = window.API.GWC_API_HOST// [ext] reference from /static/site-map.js
    apiProvider.apiConfig['LOGIN_BASE_HOST'] = window.API.LOGIN_BASE_HOST
    apiProvider.apiConfig['AUTH_HOST'] = window.API.AUTH_HOST
  } else {
    console.log(process.env.GWC_API_HOST)
    apiProvider.apiConfig['GWC_API_HOST'] = process.env.GWC_API_HOST
    apiProvider.apiConfig['LOGIN_BASE_HOST'] = process.env.LOGIN_BASE_HOST
    apiProvider.apiConfig['AUTH_HOST'] = process.env.AUTH_HOST
  }
}
// apiProvider.load()

apiProvider.apiConfig['GWC_API_HOST'] = process.env.GWC_API_HOST
apiProvider.apiConfig['LOGIN_BASE_HOST'] = process.env.LOGIN_BASE_HOST
apiProvider.apiConfig['AUTH_HOST'] = process.env.AUTH_HOST

apiProvider.mapModuleRoute = function (module = 'GWC_API_HOST') {
  // console.log(module)
  if (module) {
    if (module === 'GWC_API_HOST') {
      return apiProvider.apiConfig['GWC_API_HOST']
    }
    if (module === 'LOGIN_BASE_HOST') {
      return apiProvider.apiConfig['LOGIN_BASE_HOST']
    }
    if (module === 'AUTH_HOST') {
      return apiProvider.apiConfig['AUTH_HOST']
    }
  }
  return module
}

apiProvider.getApiAddress = function (url, module) {
  console.log(this.mapModuleRoute(module))
  let apiAddress = ''
  if (url) {
    if (url.indexOf('/') === 0) {
      apiAddress = this.mapModuleRoute(module) + url
    } else {
      apiAddress = this.mapModuleRoute(module) + '/' + url
    }
  }
  return apiAddress
}

export default apiProvider



// WEBPACK FOOTER //
// ./src/common/provider/api.provider.js